//#region DevExtreme Imports

import 'devextreme/ui/button'
import 'devextreme/ui/color_box'
import 'devextreme/ui/form'
import 'devextreme/ui/load_indicator'
import 'devextreme/ui/number_box'
import 'devextreme/ui/popup'
import 'devextreme/ui/select_box'

//#endregion

import { DashboardCreateEditPopupController } from './create-edit-popup.controller'
import { USER_SESSION_SERVICE_NAME } from '../../../services/user-session'

import { $SCOPE_SERVICE_NAME, $Q_SERVICE_NAME } from '../../../services/system'

//#region Asset Imports

import './create-edit-popup.scss'
import * as TEMPLATE from './create-edit-popup.tpl.html'

//#endregion

export const DASHBOARD_CREATE_EDIT_POPUP_NAME = 'dashboardCreateEditPopup'

export class DashboardCreateEditPopupComponent implements ng.IComponentOptions {

    controller = [$SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, USER_SESSION_SERVICE_NAME, DashboardCreateEditPopupController]

    bindings = {
        options: '<'
    } as { [index: string]: string }

    template = TEMPLATE

}